import React from 'react';
import { useSelector } from 'react-redux';

const Header = ({ logo: propLogo, logoLoading }) => {
  const { user } = useSelector((state) => state.auth);
  const logo = propLogo || user?.oemPartner?.logo || "https://washi.s3.amazonaws.com/RiskReport360.png";
  
  return (
    <div className="text-center">
      <img
        src={logo}
        alt={"Company Logo"}
        style={{ height: "100px", width: '160px', marginTop: "10px", marginBottom: "10px", objectFit: 'contain', filter: 'drop-shadow(0 0 8px rgba(0,0,0,0.3))' }}
        loading="lazy"
      />
      <h4 className="fw-bold mt-0">Cybersecurity Assessment Platform</h4>
      <p
        className="text-muted mx-auto"
        style={{ maxWidth: "810px", fontSize: "15px" }}
      >
       Comprehensive security assessment combining network discovery, vulnerability scanning, technology stack analysis, web security evaluation, infrastructure assessment, and data breach monitoring with AI-powered insights.
      </p>
    </div>
  );
};

export default Header;